/**
 * Параметры, необходимые для запуска сервиса
 */
export type InstallParameters = {
    first_packets?: Packet[];
};

/**
 * Тип события, отправляемого в DMP
 */
export enum DMPEVENT {
    USERDATA = 'userdata',
    AUTH = 'authevent',
    AD = 'adevent',
    QUIZ = 'quiz',
    ADBLOCK = 'adblock',
}

/**
 * Пакет, отправляемый в DMP, состоит из типа события и данных "data" в произвольной форме
 */
export type Packet = {
    event: DMPEVENT;
    data: object | undefined;
};

export { default as Loader } from './Loader';
